import { useQuery } from '@tanstack/react-query';

import { postData } from 'src/app/queries';

import { marketingCampaignsQueryKey } from '../marketing/get-campaigns';

type GetSavedEmailPayload = {
  TemplateId: number | null;
};

type SavedEmail = {
  HtmlBody: string;
  IsDynamic: boolean;
  JsonBody: string;
  MarketingEmailTemplateId: number;
};

export function useGetSavedEmailQuery({ templateId }: { templateId?: number | null }) {
  return useQuery({
    queryKey: [...marketingCampaignsQueryKey, 'saved-email', templateId],
    enabled: !!templateId,
    queryFn: async () =>
      postData<GetSavedEmailPayload, SavedEmail>({
        endpoint: 'api/email-marketing/get-template',
        payload: { TemplateId: templateId ?? null },
      }),
  });
}
